module.exports = __webpack_public_path__ + "media/fonts/suisse-works/SuisseWorks-BookItalic-a158b94225780250a1de8521b80814d4.otf";